import React from "react"
import { Flex, Breadcrumbs, INNER_MAX_WIDTH } from "@capioweb/ui-components"

import { BreadcrumbProps } from "../../components/Core/pageBase"

const BreadcrumbsBlock: React.FC<BreadcrumbProps> = (props) =>
	props.items?.length > 0 ? (
		<Flex w={1} px={3} backgroundColor="white" borderBottom>
			<Flex w={1} maxw={INNER_MAX_WIDTH} m="0 auto" py={2.75}>
				<Breadcrumbs
					links={props.items.reduce(
						(acc, item) => [
							...acc,
							{
								...item,
								url: item.url,
							},
						],
						[]
					)}
				/>
			</Flex>
		</Flex>
	) : null

export { BreadcrumbsBlock }
